import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useCreatePollPostMutation = createMutationHook(
  MembershipsCreatorApiClient.createPollPost,
  {
    mutationKey: ['createPollPost'],
  },
)
